import styled from "styled-components";

import { CloseButton } from "../Button";

export const CloseBtn = styled(CloseButton).attrs({
  "data-ds-component": "modal-close-button"
})`
  position: absolute;
  right: 24px;
`;
